// extracted by mini-css-extract-plugin
export default {"sticky-header":"TypeRefTable_sticky-header__VTcJq","stickyHeader":"TypeRefTable_sticky-header__VTcJq","code-bg":"TypeRefTable_code-bg__Y9DPq","codeBg":"TypeRefTable_code-bg__Y9DPq"};